<template>
  <div>
    <div v-if="Object.keys(errors).length > 0" class="alert alert-danger">
      <p v-for="error in errors" class="errors">
        {{ error }}
      </p>
    </div>
    <div>
      Set the {{ partnerLabel.toLowerCase() }}'s
      <span :class="{'has-error':errors.profileField}">
        <select :value="profileField" name="profileField" class="form-control" @change="handleChange">
          <option value="">Select one</option>
          <option v-for="(fieldLabel, id) in formattedProfileFields" :value="id">{{ fieldLabel }}</option>
        </select>
      </span>
      to
      <span :class="{'has-error':errors.modificationSource}">
        <select :value="modificationSource" name="modificationSource" class="form-control" @change="handleChange">
          <option value="" disabled>Select one</option>
          <option v-for="(display, $id) in availableModificationSources" :value="$id">{{ display }}</option>
        </select>
      </span>

      <select :value="exportTag" name="exportTag" class="form-control" @change="handleChange">
        <option value="" selected="selected" disabled>Select one</option>
        <option v-if="modificationSource == 'event'" v-for="(eventSourceField) in config.sourceFields" :value="eventSourceField.tag">{{ eventSourceField.tag }}</option>
        <option v-if="modificationSource == 'block'" v-for="(blockSourceField) in config.blockFields" :value="blockSourceField.tag">{{ blockSourceField.tag }}</option>
      </select>
    </div>
  </div>
</template>

<script>
  import BaseComponent from '@/EventLogic/components/BaseComponent.vue';
  import {enumValidator} from "@/EventLogic/util";
  import {capitalize} from "@/EventLogic/util";

  export default {
    filters: {
      capitalize
    },
    extends: BaseComponent,
    props: {
      id: String,
      profileField: {
        type: String
      },
      modificationSource: {
        type: String,
        validator: enumValidator(['event', 'block'])
      },
      exportTag: {
        // the aFormField whose value will be used to set the subject profile field
        type: String
      },
    },
    computed: {
      availableModificationSources: function() {
        var availableSources = {};

        if (this.config.sourceName) {
          availableSources.event = 'this event\'s data';
        }

        if (Object.keys(this.config.blockFields).length) {
          availableSources.block = 'this block\'s data';
        }

        return availableSources;
      },
      formattedProfileFields: function () {
        let typesMap = {};
        Object.keys(this.config.supportPartnerProfileFields).map((fieldType) => {
          switch (fieldType) {
            case 'cell_phone':
              typesMap[fieldType] = 'Text Number';
              break;
            case 'home_phone':
              typesMap[fieldType] = 'Voice Number';
              break;
            default:
              // shouldn't end up here but whatever
              typesMap[fieldType] = capitalize(fieldType);
          }
        });
        return typesMap;
      },
      partnerLabel() {
        return this.config.supportPartnerLabel;
      },
    },
    methods: {
      validate: function() {
        this.errors = {};

        if (!this.profileField) {
          this.errors.profileField = "Please select a profile field to modify.";
        }
        if (!this.modificationSource) {
          this.errors.modificationSource = "Please select a source from which to populate the profile field from.";
        }
        if (!this.exportTag) {
          this.errors.exportTag = "Please select a field.";
        }

        return Object.keys(this.errors).length === 0;
      }
    }
  };
</script>
